import { NgModule } from '@angular/core';

import { PortalOutletDirective } from './portal-outlet.directive';

@NgModule({
  exports: [PortalOutletDirective],
  declarations: [PortalOutletDirective],
})
export class PortalModule {}
